export default "__VITE_ASSET__C5ZTIuB8__"